import { render, staticRenderFns } from "./DownloadArrow.vue?vue&type=template&id=3786013a&scoped=true&"
import script from "./DownloadArrow.vue?vue&type=script&lang=js&"
export * from "./DownloadArrow.vue?vue&type=script&lang=js&"
import style0 from "./DownloadArrow.vue?vue&type=style&index=0&id=3786013a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3786013a",
  null
  
)

export default component.exports